<template>
  <el-dialog
    :title="this.type != 'new' ? $t('app.edit') : $t('app.new')"
    :visible.sync="dialogVisible"
    :modal-append-to-body="false"
    width="500px"
  >
    <el-input
      v-model="schoolYear"
      size="small"
      disabled
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.bedTags.schoolYear')"
    >
    </el-input>
    <el-input
      v-model="code"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.bedTags.code')"
    >
    </el-input>
    <el-input
      type="text"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      v-model="name"
      :placeholder="$t('app.bedTags.name')"
    >
    </el-input>
    <el-select
      v-model="isUse"
      size="small"
      style="margin-bottom: 20px; width: 100%"
      :placeholder="$t('app.validation.select') + $t('app.enable')"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-input
      type="textarea"
      size="small"
      style="margin-bottom: 20px"
      v-model="description"
      :placeholder="$t('app.description')"
    >
    </el-input>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        @click="handleClose"
        >{{ $t("app.confirm") }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { addChild, update } from "@/api/systemManagement/bedTagsManagement";
export default {
  data() {
    return {
      pid: "",
      code: "",
      name: "",
      sort: "",
      isUse: null,
      description: "",
      schoolYear: "",
      options: [
        {
          value: true,
          label: this.$t("app.isUse")
        },
        {
          value: false,
          label: this.$t("app.disable")
        }
      ],

      loading: false,
      dialogVisible: false,
      index: "",
      type: ""
    };
  },
  methods: {
    edit(index, row) {
      //console.log(row);
      this.dialogVisible = true;
      this.code = row.Code;
      this.name = row.Name;
      this.sort = row.sort;
      this.isUse = "true" == row.IsUse ? true : false;
      this.schoolYear = row.SchoolYear;
      this.description = row.Description;
      this.index = index;
      this.id = row.Id;
      this.pid = row.Pid;
      this.type = "edit";
    },
    add(pid, schoolYear) {
      //console.log("pid: " + pid + "             schoolYear:" + schoolYear);
      this.dialogVisible = true;
      this.type = "new";
      this.code = "";
      this.name = "";
      this.sort = "99";
      this.index = "";
      this.isUse = null;
      this.schoolYear = schoolYear;
      this.description = "";
      this.pid = pid;
    },
    handleClose() {
      this.$confirm(
        (this.type === "edit"
          ? this.$t("app.confirmModification")
          : this.$t("app.confirmAdd")) + "?"
      ).then(() => {
        this.loading = true;
        if (this.type === "edit") {
          update({
            SchoolYear: this.schoolYear,
            Code: this.code,
            Name: this.name,
            Description: this.description,
            SortNumber: this.sort,
            IsUse: this.isUse,
            Pid: this.pid,
            Id: this.id
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          addChild({
            SchoolYear: this.schoolYear,
            Code: this.code,
            Name: this.name,
            Description: this.description,
            SortNumber: this.sort,
            IsUse: this.isUse,
            Pid: this.pid
          })
            .then(() => {
              this.success();
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    success() {
      this.$message({
        message: this.$t("app.opeSuccess"),
        type: "success"
      });
      if (this.type === "edit") {
        this.$emit("handleSuccess", this.index, {
          SchoolYear: this.schoolYear,
          Code: this.code,
          Name: this.name,
          IsUse: this.isUse,
          Description: this.description,
          Sort: this.sort,
          Pid: this.pid,
          Id: this.id
        });
      } else {
        //console.log("^^^^^^^^^: " + this.schoolYear);
        this.$emit("handleAdd", {
          SchoolYear: this.schoolYear,
          Code: this.code,
          Name: this.name,
          IsUse: this.isUse,
          Description: this.description,
          Pid: this.pid,
          Id: this.id
        });
      }
      this.loading = false;
      this.dialogVisible = false;
    }
  }
};
</script>
